import GetTokenRequestModelBase from '../_generated/modelBases/get-token-request-model-base';

export default class GetTokenRequestModel extends GetTokenRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
